import { Injectable } from '@angular/core';

import { usuariosRoute } from "./data.service";
import { AuthService } from "../../../shared/services/auth.service";
import { recursosHumanosRoute } from "../../shared/data.service";

@Injectable()
export class UsuarioNavigationService {
    moduleRouter: string = usuariosRoute;
    fatherRouter: string = recursosHumanosRoute;

    constructor(
        private _authService: AuthService
    ) { }

    goToChange() {
        let router: string = this.fatherRouter + '/' + this.moduleRouter + '/trocar';
        this._authService.navigateTo(router);
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/usuarios/shared/usuario-navigation.service.ts
 **/